import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSkyComponent } from './simple-icons-sky.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSkyComponent ],
    exports:      [ SimpleIconsSkyComponent ],
    bootstrap:    []
})
export class SimpleIconsSkyModule {}
